import { Container } from './styled'

export const Loader = () => (
  <Container>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <circle
        cx="14"
        cy="14"
        r="14"
        transform="translate(2 2)"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeDasharray="87.97"
      />
    </svg>
  </Container>
)
